import * as React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export default function Loading() {
  return (
    <Box sx={{
      display: 'flex',
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginLeft: '-25px',
      margintop: '-25px',
    }}
    >
      <CircularProgress />
    </Box>
  );
}
